/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgUnitReserveListPathOrgUnitId, OrgUnitReserveListStatus200 } from "../types/OrgUnitReserveList.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orgUnitReserveList } from "../requests/orgUnitReserveList.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orgUnitReserveListQueryKey = (org_unit_id?: MaybeRefOrGetter<OrgUnitReserveListPathOrgUnitId>) =>
	[{ url: "/api/org_unit/:org_unit_id/reserve/", params: { org_unit_id: org_unit_id } }] as const;

export type OrgUnitReserveListQueryKey = ReturnType<typeof orgUnitReserveListQueryKey>;

export function orgUnitReserveListQueryOptions(
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveListPathOrgUnitId>,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const queryKey = orgUnitReserveListQueryKey(org_unit_id);
	return queryOptions<OrgUnitReserveListStatus200, ResponseErrorConfig<Error>, OrgUnitReserveListStatus200>({
		enabled: () => !!toValue(org_unit_id),
		queryKey,
		queryFn: async ({ signal }) => {
			return orgUnitReserveList(toValue(org_unit_id!), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * @summary список броней гостя на точке
 * {@link /api/org_unit/:org_unit_id/reserve/}
 */
export function useOrgUnitReserveList<
	TData = OrgUnitReserveListStatus200,
	TQueryData = OrgUnitReserveListStatus200,
	TQueryKey extends QueryKey = OrgUnitReserveListQueryKey,
>(
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveListPathOrgUnitId>,
	options: {
		query?: Partial<UseQueryOptions<OrgUnitReserveListStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey =
		(resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? orgUnitReserveListQueryKey(org_unit_id);

	const query = useQuery(
		{
			...orgUnitReserveListQueryOptions(org_unit_id, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<OrgUnitReserveListStatus200, ResponseErrorConfig<Error>, TData, OrgUnitReserveListStatus200, TQueryKey>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
